import { NgModule } from '@angular/core';

import { DrawerComponent } from './drawer.component';
import { PortalModule } from '@angular/cdk/portal';
import { DrawerService } from './drawer.service';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
    imports: [
        MatSidenavModule,
        PortalModule
    ],
    declarations: [
        DrawerComponent
    ],
    exports: [
        DrawerComponent
    ],
    providers: [
        DrawerService
    ]
})
export class DrawerModule {
}
